import { ApiProperty } from "@nestjs/swagger";

export class JobworkIdReq {
    @ApiProperty()
    jobworkId: number;
    vendorId: number;
}